import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMsofficeControl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 21,
	viewBox: "0 0 24 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5 20H6.5L1 10.5L6.5 1H17.5L23 10.5L17.5 20Z",
		stroke: "currentColor"
	})
});
export default SvgIconMsofficeControl;
